export interface ViewportSizes {
  width: number;
  height: number;
}

export function getViewportSizes(): ViewportSizes {
  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  window.addEventListener('resize', () => {
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;
  });

  return sizes;
}
